export default "__VITE_ASSET__DySo2dG___"